<template>
  <app-layout>
    <div class="gift-destinations-page">
      <div class="selects">
        <div class="container flex flex-col sm:flex-row">
          <v-select
            :items="origins"
            class="select-origins js-prepend-custom-icons js-replace-arrows grow-0 mr-0 sm:mr-4 mb-4 sm:mb-0"
            prepend-inner-icon="airplane"
            v-model="form.origin_id"
            outlined
            rounded
            background-color="#fff"
            hide-details
            height="50"
            item-text="name"
            item-value="id"
          ></v-select>
          <v-select
            :items="personsItems"
            class="select-passengers js-prepend-custom-icons js-replace-arrows grow-0"
            prepend-inner-icon="user"
            v-model="form.passengers"
            outlined
            rounded
            background-color="#fff"
            hide-details
            height="50"
          ></v-select>
        </div>
      </div>
      <div class="container mx-auto">
        <v-row class="grid-cards">
          <v-col
            v-for="destination in destinations"
            :key="destination.id"
            :xs="12"
            :sm="6"
            :md="4"
            class="py-4 md:p-3 lg:p-4"
          >
            <app-gift-card-destination
              :destination="destination"
            ></app-gift-card-destination>
          </v-col>
        </v-row>
      </div>
    </div>
  </app-layout>
</template>

<script lang="ts">
import { LOAD_GIFTS_LOCATIONS } from "../../store/gifts/action-types";
import { GIFTS_GET_DESTINATIONS, GIFTS_GET_ORIGINS_WITH_DESTINATIONS } from "../../store/gifts/getter-types";
import { SET_GIFTS_STATE } from "../../store/gifts/mutation-types";
import prependCustomIcons from '../../utils/mixins/prependCustomIcons';
import replaceArrows from '../../utils/mixins/replaceArrows';

export default {
  mixins: [prependCustomIcons, replaceArrows],
  data() {
    return {
      form: {
        passengers: this.$store.state.gifts.passengers,
        origin_id: this.$store.state.gifts.origin_id
      }
    }
  },
  computed: {
    origins() {
      return this.$store.getters[GIFTS_GET_ORIGINS_WITH_DESTINATIONS];
    },
    destinations() {
      return this.$store.getters[GIFTS_GET_DESTINATIONS];
    },
    personsItems() {
      let options = [];

      for (let i = 1; i <= 10; i++) {
        options.push({
          text: i + " " + this.$tc('shared.person', i),
          value: i,
        });
      }
      return options;
    },
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        this.$store.commit(SET_GIFTS_STATE, [
          {
            prop: "origin_id",
            value: form.origin_id
          },
          {
            prop: "passengers",
            value: form.passengers
          }
        ]);
      }
    }
  },
  async created() {
    if (! this.origins.length) {
      await this.$store.dispatch(LOAD_GIFTS_LOCATIONS);
      this.$store.commit(SET_GIFTS_STATE, { prop: "origin_id", value: this.origins[0].id });
      this.form.origin_id = this.origins[0].id;
    }
  }
};
</script>

<style lang="scss" scoped>
.selects {
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);

  > .v-input {
    width: 100%;
  }

  @media (max-width: 639px) {
    padding: 0.5rem 0;

    .select-origins {
      margin-right: 0 !important;
    }
  }
  @media (min-width: 640px) {
    .select-origins {
      width: 304px !important;
      margin-right: 0.75rem !important;
      margin-bottom: 0 !important;
    }
    .select-passengers {
      width: 204px !important;
    }
  }
}
.page-results {
  .grid-cards {
    padding: 5rem 0 7.5rem;
  }
}
@media (min-width: 640px) {
  .sm\:mb-0 {
    margin-bottom: 0 !important;
  }
  .sm\:mr-4 {
    margin-right: 1rem !important;
  }
}
</style>
